<template>
  <div class="component-selector">
    <div class="component-header">
      <span>造型</span>
      <hr/>
    </div>
    <list-view class="component-container">
      <div class="component" v-for="option in options" v-on:click="componentSelected(option.id)" v-bind:selected="option.selected">
        <div class="component-image">
          <i v-if="option.id" v-bind:class="'icon-' + option.id"></i>
          <div v-if="!option.id" class="empty-placeholder"></div>
        </div>
        <div>{{ option.name }}</div>
        <div class="component-dimension" v-if="option.dimension">
          <div>{{ option.dimension.depth }}mm 長</div>
          <div>{{ option.dimension.width }}mm 寬</div>
          <div>{{ option.dimension.height }}mm 高</div>
        </div>
        <div v-if="option.price"><span class="price-unit">NT$</span> {{ option.price | priceTag }}</div>
      </div>
    </list-view>
  </div>
</template>

<script>
import listView from 'components/list-view';
import ComponentDatabase from 'services/component-database';
import l10n from 'services/l10n-service';
import Utils from 'utils/utils';

import 'styles/pileup-font.css';

export default {
  name: 'component-selector',
  props: [
    'mode', // determine whether this selector is for combination components
    'isRequired',
    'componentType',
    'value', 'index', // for oridnary components
    'componentsInUse' // for combination components
  ],
  data() {
    return {};
  },
  components: {
    listView
  },
  computed: {
    isForCombination() {
      return this.mode === 'combination';
    },
    title() {
      if (this.isForCombination) {
        return l10n.get('combination');
      } else {
        return l10n.get(this.componentType);
      }
    },
    options() {
      if (this.isForCombination) {
        return this.getCombinationOptions(this.componentType);
      } else {
        return this.getComponentOptions(this.componentType);
      }
    }
  },
  filters: {
    priceTag: Utils.priceTag
  },
  methods: {
    getCombinationOptions(componentType) {
      return ComponentDatabase.getCombinationComponentsByType(componentType)
        .map((combinationComponent) => {
          return {
            selected: this.isCombinationComponentInUse(combinationComponent),
            id: combinationComponent.id,
            name: combinationComponent.name,
            dimension: combinationComponent.dimension,
            price: combinationComponent.price
          };
        });
    },
    getComponentOptions(componentType) {
      return (this.isRequired ? [] : [{
        name: '無',
        id: null
      }]).concat(ComponentDatabase.getComponentsByType(componentType))
        .filter((component) => {
          // do not display combination components
          return component &&
            (!component.tag || component.tag.indexOf('combination') < 0);
        }).map((component) => {
          return {
            selected: this.value === component.id,
            id: component.id,
            name: component.name,
            dimension: component.dimension,
            price: component.price
          };
        });
    },
    isCombinationComponentInUse(combinationComponent) {
      const components = this.componentsInUse[this.componentType] &&
        this.componentsInUse[this.componentType].components;
      return components && !!components.find((component) => {
        return combinationComponent.id === component.id;
      });
    },
    componentSelected(componentId) {
      if (this.isForCombination) {
        // XXX: the index of combination component is 0 for this time being.
        this.$emit('component-selected', this.componentType, 0, componentId);
      } else {
        this.$emit('component-selected', this.componentType, this.index,
          componentId);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
  pointer-events: auto;
}
.component-selector {
  padding: 10px 20px;
}
.component-header {
  position: relative;
  height: 22px;
}
.component-header span {
  position: relative;
  display: inline-block;
  background: white;
  padding-right: 15px;
  z-index: 1;
}
.component-header hr {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
}
.component-container {
  /* padding for scrollbar */
  padding-bottom: 5px;
  font-size: 14px;
}
.component {
  padding: 5px 15px 15px 15px;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.component-image {
  height: 100px;
  margin: 10px auto;
  font-family: "pileup";
  font-size: 100px;
  color: #A9ACA6;
  vertical-align: middle;
}
.component-image i {
  position: relative;
}
.component-image i:after {
  color: #CCCCCC;
}
.component[selected],
.component[selected] .component-image {
  color: #6DADAD;
}
.component[selected] .component-image i:after {
  color: #AED3D3;
}
.component-image .empty-placeholder {
  width: 45px;
  height: 70px;
  border: 2px dashed #A9ACA6;
  border-radius: 5px;
  display: inline-block;
  text-align: center;
}
.component[selected] .component-image .empty-placeholder {
  border: 2px dashed #6DADAD;
}
.component:hover {
  background: #F0F0F0;
}
.component-dimension {
  padding: 10px 0;
  display: inline-block;
  text-align: right;
  font-size: 12px;
  margin: 0 auto;
}
.price-unit {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// component-selector.vue?71a0dfff